import { Redirect, useHistory, useParams, useRouteMatch } from "react-router";
import { useGetPersonIdFromUser } from "../../../hooks/useGetUser";
import {
  PageHeader,
  VerticalTabsLayout,
  Card,
  Unauthorized,
} from "@velocity-ehs/component-library";
import { useTranslation } from "react-i18next";
import FormSkeleton from "../../sharedComponents/FormSkeleton";

const RedirectToPersons = () => {
  const { id } = useParams() as { id: string };

  const { isLoading, user, isError } = useGetPersonIdFromUser(id);

  const { t } = useTranslation();

  const match = useRouteMatch();

  const history = useHistory();

  if (isLoading) {
    return (
      <>
        <PageHeader
          title={undefined}
          navigationTree={[
            { text: `Accelerate ${t("universal_Home")}`, href: "/" },
            { text: t("universal_Users"), href: "/user" },
            { text: t("action_edit"), href: "" },
          ]}
        />
        <VerticalTabsLayout
          tabs={[
            {
              content: (
                <Card title={t("profile_Personal_Details_Tab")}>
                  <FormSkeleton rows={5} />
                </Card>
              ),
              title: t("universal_Users"),
            },
          ]}
          pathname={match.url}
          routeMatch={match}
          toRoute={history.push}
        />
      </>
    );
  }

  if (isError) {
    return <Unauthorized navigate={history.push} />;
  }

  return <Redirect to={`/person/${user.person.id}/edit`} />;
};

export { RedirectToPersons };
